<template>
  <div class="fill-height py-16">
    <div class="pa-16">
      <v-row>
        <v-col class="user-section" cols="12" lg="6" md="6">
          <v-card class="d-flex flex-column justify-center align-center">
            <v-card-title
              primary-title
              class="accentDarkBlue white--text font-weight-medium"
              style="width: 100%"
              ><v-row justify="center">Profil</v-row></v-card-title
            >
            <div class="py-10" style="width: 80%;">
              <v-row align="center">
                <div
                  class="
                    icon-radius
                    pa-3
                    blue-grey
                    lighten-5
                    mr-5
                    hidden-sm-and-down
                  "
                >
                  <v-icon size="40" color="black">mdi-account-outline</v-icon>
                </div>
                <div class="card-text">{{ user.name }}</div>
              </v-row>
              <v-row align="center" class="my-5">
                <div
                  class="
                    icon-radius
                    pa-3
                    blue-grey
                    lighten-5
                    mr-5
                    hidden-sm-and-down
                  "
                >
                  <v-icon size="40" color="black">mdi-email-outline</v-icon>
                </div>
                <div class="card-text">{{ user.username }}</div>
              </v-row>

              <v-row align="center">
                <div
                  class="
                    icon-radius
                    pa-3
                    blue-grey
                    lighten-5
                    mr-5
                    hidden-sm-and-down
                  "
                >
                  <v-icon size="40" color="black">mdi-whatsapp</v-icon>
                </div>
                <div class="card-text">{{ user.handphone }}</div>
              </v-row>
              <v-row>
                <v-col
                  :cols="
                    siswa.siswaStatus >= 0 && siswa.siswaStatus < 3 ? '6' : '12'
                  "
                  sm="12"
                  v-if="siswa.siswaStatus >= 0 && siswa.siswaStatus < 3"
                >
                  <v-btn
                    style="width: 100%; font-size: 1rem"
                    color="accentDarkBlue"
                    outlined
                    class="white--text py-6 mt-5"
                    @click="editForm"
                    >Edit Formulir</v-btn
                  >
                </v-col>
                <v-col
                  sm="12"
                  :cols="
                    siswa.siswaStatus >= 0 && siswa.siswaStatus < 3 ? '6' : '12'
                  "
                >
                  <v-btn
                    style="width: 100%; font-size: 1rem"
                    color="accentDarkBlue"
                    class="white--text py-6 mt-5"
                    @click="logout"
                    >Logout</v-btn
                  >
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="6" lg="6">
          <v-card
            v-if="hasStudent"
            class="d-flex flex-column justify-center align-center"
          >
            <v-card-title
              primary-title
              class="accentDarkBlue white--text font-weight-medium"
              style="width: 100%"
              ><v-row justify="center">Calon Peserta Didik</v-row></v-card-title
            >

            <div class="py-10" style="width: 80%">
              <div
                v-if="hasPengumuman && siswa.idStatus != ''"
                class="headline mb-5"
                :class="
                  siswa.idStatus.includes('Tidak lolos')
                    ? 'red--text'
                    : 'green--text'
                "
              >
                <div
                  class="pa-3"
                  :class="
                    siswa.idStatus.includes('Tidak lolos')
                      ? 'card-red'
                      : 'card-green'
                  "
                >
                  <v-row align="center px-5" >
                    <v-avatar
                      :color="
                        siswa.idStatus.includes('Tidak lolos') ? 'red' : 'green'
                      "
                      size="35"
                      class="hidden-sm-and-down"
                      ><v-icon
                        v-if="siswa.idStatus.includes('Tidak lolos')"
                        color="white"
                        >mdi-close</v-icon
                      >
                      <v-icon v-else color="white">mdi-check</v-icon>
                    </v-avatar>
                    <div class="ml-3">{{ siswa.idStatus }}</div>
                  </v-row>
                </div>
              </div>
              <div>
                <div class="grey--text text--darken-2 student-title mb-1">
                  Nama
                </div>
                <div class="card-text">{{ siswa.name }}</div>
              </div>
              <div class="my-5">
                <div class="grey--text text--darken-2 student-title mb-1">
                  Jurusan
                </div>
                <div class="card-text">{{ siswa.major }}</div>
              </div>
              <div>
                <div class="grey--text text--darken-2 student-title mb-1">
                  Tahap Pendaftaran
                </div>
                <div
                  class="card-text"
                  v-if="!cekStatus() || siswa.idPengumuman < 9"
                >
                  {{ siswa.status }}
                </div>
                <div
                  class="card-text"
                  v-else-if="cekStatus() && siswa.idPengumuman > 8"
                >
                  {{ siswa.status }} <a href="/informasi">Informasi</a>
                </div>
              </div>

              <!-- <v-row>
                <v-col xs="6" sm="6" md="3" cols="12">
                  <div>
                    <div class="caption grey--text">Nama</div>
                    <div>
                      <div>{{ siswa.name }}</div>
                    </div>
                  </div>
                </v-col>
                <v-col xs="6" sm="6" md="3" cols="12">
                  <div class="caption grey--text">Jurusan</div>
                  <div>{{ siswa.major }}</div>
                </v-col>
                <v-col xs="6" sm="6" md="6" cols="12">
                  <div class="caption grey--text">Tahap Pendaftaran</div>
                  <div v-if="!cekStatus() || siswa.idPengumuman < 9">
                    {{ siswa.status }}
                  </div>
                  <div v-else-if="cekStatus() && siswa.idPengumuman > 8">
                    {{ siswa.status }} <a href="/informasi">Informasi</a>
                  </div>
                </v-col>
              </v-row> -->
            </div>
          </v-card>

          <v-card class="siswa-card px-5" v-if="!hasStudent">
            <v-container grid-list-xs>
              <center>
                <p class="card-text">
                  Anda belum mendaftar sebagai siswa, silakan daftar di menu
                  Beranda.
                </p>
              </center>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { EventBus } from "../event-bus";

export default {
  data: () => ({
    user: {
      id: "",
      username: "",
      name: "",
      handphone: "",
    },
    siswa: {
      name: "",
      major: "",
      status: "",
      idStatus: "",
      idPengumuman: "",
      siswaStatus: -1,
    },
    hasStudent: true,
    hasPengumuman: false,
  }),
  methods: {
    async thingsAfterResult() {
      EventBus.$emit("startLoading");
      const cekRes = await axios.post(`${this.$api}/cek-pengumuman`, {
        u_id: localStorage.getItem("id"),
      });

      try {
        if (cekRes.data.STATUS == "ERROR") {
          localStorage.removeItem("hasCekPengumuman");
        } else if (cekRes.data.PAYLOAD.data.show_pengumuman == "Y") {
          localStorage.setItem("hasCekPengumuman", localStorage.getItem("id"));
        }
      } catch (e) {
        console.log(e);
      }

      this.cekPengumuman();

      EventBus.$emit("stopLoading");
    },
    cekStatus() {
      if (localStorage.getItem("hasCekPengumuman") === this.user.id)
        return true;
      else return false;
    },
    cekPengumuman() {
      if (
        localStorage.getItem("hasCekPengumuman") == localStorage.getItem("id")
      ) {
        this.hasPengumuman = true;
      } else {
        this.hasPengumuman = false;
      }
    },
    async getAndSetUser() {
      EventBus.$emit("startLoading");

      let id = localStorage.getItem("id");
      this.user.id = id;

      const profileRes = await axios.get(`${this.$api}/profile?id=${id}`);
      const res = profileRes.data;

      if (res.STATUS === "SUCCES") {
        this.user.username = res.PAYLOAD.u_username;
        this.user.name = res.PAYLOAD.u_nama;
        this.user.handphone = res.PAYLOAD.u_no_hp;
        this.siswa.name = res.PAYLOAD.sw_nama_lengkap;
        this.siswa.major = res.PAYLOAD.sw_jurusan;

        const status = res.PAYLOAD.sw_status;
        this.siswa.idPengumuman = status;
        this.siswa.siswaStatus = status;

        if (status === 0)
          this.siswa.status = "Menunggu formulir diverifikasi admin";
        else if (status === 1)
          this.siswa.status =
            "Menunggu upload ulang berkas yang sudah ditolak oleh admin";
        else if (status === 2)
          this.siswa.status =
            "Menunggu berkas yang di-upload ulang diverifikasi admin";
        else if (status === 3)
          this.siswa.status =
            "Formulir pendaftaran telah diverifikasi oleh admin dan belum membayar";
        else if (status === 4)
          this.siswa.status = "Menunggu pembayaran diverifikasi oleh admin";
        else if (status === 5)
          this.siswa.status =
            "Menunggu upload ulang struk pembayaran yang sudah ditolak oleh admin";
        else if (status === 6)
          this.siswa.status =
            "Menunggu struk pembayaran yang di-upload ulang diverifikasi admin";
        else if (status === 7)
          this.siswa.status =
            "Pembayaran telah diverifikasi oleh admin dan pendaftaran siswa berhasil";
        else if (status === 8 && this.hasPengumuman) {
          this.siswa.status = "Tidak lolos seleksi";
          this.siswa.idStatus = `Tidak lolos di ${this.siswa.major}`;
        } else if (status === 9 && this.hasPengumuman) {
          this.siswa.status = "Lolos seleksi. Silakan cetak hasil seleksi di ";
          this.siswa.idStatus = `Diterima di ${this.siswa.major}`;
        } else if (status === 10 && this.hasPengumuman) {
          this.siswa.status = "Cadangan. Silakan cetak hasil seleksi di ";
          this.siswa.idStatus = `Cadangan di ${this.siswa.major}`;
        } else if (status === 11 && this.hasPengumuman) {
          this.siswa.status =
            "Diterima di DKV Konsentrasi Teknik Grafika (Rekomendasi dari DKV Konsentrasi Desain Grafika). Silakan cetak hasil seleksi di ";
          this.siswa.idStatus = `Diterima di DKV Konsentrasi Teknik Grafika (Rekomendasi dari DKV Konsentrasi Desain Grafika)`;
        } else {
          this.siswa.status = "Menunggu pengumuman hasil seleksi";
        }
      } else if (
        res.STATUS === "ERROR" &&
        res.MESSAGE === "Data siswa tidak valid"
      ) {
        this.user.username = res.PAYLOAD.u_username;
        this.user.name = res.PAYLOAD.u_nama;
        this.user.handphone = res.PAYLOAD.u_no_hp;

        this.hasStudent = false;
      }

      // if (
      //   (localStorage.getItem("hasDapodik") != null ||
      //     localStorage.getItem("hasDapodik") != undefined) &&
      //   this.siswa.idPengumuman > 8
      // ) {
      //   this.siswa.idPengumuman = 100;
      //   this.siswa.status =
      //     "Anda telah melengkapi dapodik. Silakan cetak hasil seleksi dan cek alur daftar ulang di ";
      // } else {
      //   localStorage.removeItem("hasDapodik");
      // }

      EventBus.$emit("stopLoading");
    },

    logout() {
      EventBus.$emit("startLoading");

      localStorage.removeItem("id");
      localStorage.removeItem("username");
      localStorage.removeItem("token");
      localStorage.removeItem("hasCekPengumuman");
      localStorage.removeItem("sw_status");
      localStorage.removeItem("hasRegister");
      localStorage.removeItem("hasDapodik");
      localStorage.removeItem("isVerified");

      EventBus.$emit("triggerCheckLoginToken");
      EventBus.$emit("stopLoading");

      this.$router.push({ name: "home" });
    },
    editForm() {
      this.$router.push({ name: "editStudentRegister" });
    },
  },
  async mounted() {
    axios.defaults.headers.common = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };
    if (localStorage.getItem('isVerified' == 'true')) {
      await this.thingsAfterResult();
    }
    await this.getAndSetUser();
  },
};
</script>

<style scoped>
.card-red {
  border-radius: 10px;
  background-color: #f2b6b6;
  color: #783f3f;
}

.card-green {
  border-radius: 10px;
  background-color: #c7f0e1;
  color: #3f786b;
}

.icon-radius {
  border-radius: 7px !important;
}

.profile-section {
  position: relative;
}

.card-text {
  font-size: 1.2rem;
}

.banner-section {
  position: absolute;
  min-height: 300px;
  width: 100%;
  background: #2a429e;
  top: 0;
  left: 0;
}

.profile-content {
  width: 70%;
  margin: 150px auto;
  z-index: 1;
}

.user-section {
  min-height: 200px;
  width: 100%;
}

.user-card {
  padding: 60px 0;
  margin-bottom: 80px;
}

.siswa-card {
  border-top: 7px solid #24305E;
  padding: 60px 0;
}

.info-siswa {
  display: grid;
  grid-template-columns: 200px auto;
}

@media screen and (max-width: 920px) {
  .info-siswa {
    display: grid;
    grid-template-columns: 135px auto;
  }

  .info-siswa h3 {
    font-size: 14px;
  }
}
</style>